import React from 'react';

const FinalScore = ({ score, total, onRestart, onShowReview, quizType }) => {
  const percentage = Math.round((score / total) * 100);
  
  const getMessage = () => {
    if (percentage >= 90) {
      return 'Outstanding! You know the Red Tavern menu like a pro! 🍽️';
    } else if (percentage >= 75) {
      return 'Great job! You have excellent knowledge of our menu! 👏';
    } else if (percentage >= 60) {
      return 'Good work! You know quite a bit about our offerings! 👍';
    } else if (percentage >= 40) {
      return 'Not bad! There\'s room to learn more about our delicious menu! 📚';
    } else {
      return 'Keep exploring! There\'s so much more to discover at Red Tavern! 🔍';
    }
  };

  return (
    <div className="final-score-container">
      <div className="progress">Quiz Complete!</div>
      
      <div className="final-score">
        <div className="score-display">
          <div>Final Score: {score} / {total}</div>
          <div>Percentage: {percentage}%</div>
          <div className="message">{getMessage()}</div>
        </div>
        
        <div className="score-actions">
          <button className="review-button" onClick={onShowReview}>
            📋 Review Answers
          </button>
          
          <button className="restart-button" onClick={onRestart}>
            🔄 Take Quiz Again
          </button>
        </div>
      </div>
      
      <a 
        href="https://google.com/search?q=Red%20Tavern%20menu" 
        target="_blank" 
        rel="noopener noreferrer"
        className="lookup-link"
      >
        Look Up Red Tavern Menu
      </a>
    </div>
  );
};

export default FinalScore; 